import { createAction } from '@reduxjs/toolkit'
import baseApi from '../apis/base.api'

export const logoutUser = createAction('USER_LOGOUT')

export const logoutMiddleware = () => next => action => {
    if (action.type === logoutUser.type) {
        baseApi.util.resetApiState()
    }
    return next(action)
}
